import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from "@angular/core";
import { Data } from "@angular/router";
import { AuthService } from "@core/auth.service";
import * as moment from "moment";
import { takeUntil } from "rxjs/operators";
import { StoreRepositoryService } from "src/app/pages/store/store-repository.service";
import { JackpotTriggersService } from "src/app/services/jackpot-triggers.service";
import { Subject } from "rxjs";
@Component({
    selector: "app-count-down-timer",
    template: `<span>{{ displayString ? displayString : "Expired" }}</span>`,
    styleUrls: ["./count-down-timer.component.scss"],
    standalone: true,
})
export class CountDownTimerComponent implements OnInit, OnChanges {
  _to: NodeJS.Timeout;
  translatedData: Data;
  expired: string;

  @Input()
  end: any;

  @Input()
  sec: number;

  @Input()
  flash: boolean = false;

  @Input()
  type: any;
  @Output() remainingTime = new EventEmitter<number>();
  @Output() remainingVoucherTime = new EventEmitter<number>();

  givenDate: any;
  displayString: string = "Loading..";
  private destroySubscription$ = new Subject<void>();
  userId: string;
  constructor(private jackpotTriggerService: JackpotTriggersService, private authService: AuthService, private storeRepositoryService: StoreRepositoryService) {
    try {
      this.authService.userDetails$?.subscribe((user: Data) => {
        const languageCode = user?.language_code ? user?.language_code : "en";
        this.jackpotTriggerService?.getTranslatedData(languageCode)?.subscribe(
          (data) => {
            this.translatedData = data?.["dynamic_value"];
            this.expired = this.translatedData?.expired;
            // After updating expired, update display string
             this._displayString();
          },
          (err) => {
            return err;
          }
        );
      });
    } catch (e) {
      return e;
    }
  }

  async ngOnInit() {
    await this.authService
      ?.getUid("CountDownTimerComponent")
      ?.then((uid) => {
        this.userId = uid;
      })
      .catch((error) => {
        return error;
      });
  }

  ngOnChanges() {
    if (this.type == "seconds") {
      this.end = parseInt(this.end) * 1000;
    }
    this.givenDate = new Date(this.end);
    this._displayString();
    this._to = setInterval(() => this._displayString(), 1000 * 60);
  }

  _displayString() {
    const now: any = new Date();
    let diff = moment(this.givenDate).diff(moment(now));
    this.remainingTime.emit(diff);
    this.remainingVoucherTime.emit(diff);
    if (diff >= 0) {
      this.displayString = this.formattedDiffDates(moment(this.givenDate), moment(now));
    } else {
      this.displayString = this.expired;
      if (this.flash) {
        this.storeRepositoryService.flashSaleBannerExpired$.next(true);
        const req = {
          userId: this.userId,
          page: "store",
          method: "createStoreBanners",
        };
        this.authService.updateMainPageSubscription = this.authService
          .updateMainPages(req)
          .pipe(takeUntil(this.destroySubscription$))
          .subscribe();
      }
      clearInterval(this._to);
    }
  }

  private formattedDiffDates(date1: moment.Moment, date2: moment.Moment): string {
    let years = date1.diff(date2, "year");
    date2?.add(years, "years");

    let months = date1.diff(date2, "months");
    date2?.add(months, "months");

    let weeks = date1.diff(date2, "weeks");
    date2?.add(weeks, "weeks");

    let days = date1.diff(date2, "days");
    date2?.add(days, "days");

    let hours = date1.diff(date2, "hours");
    date2?.add(hours, "hours");

    let minutes = date1.diff(date2, "minutes");
    date2?.add(minutes, "minutes");

    let seconds = date1.diff(date2, "seconds");
    date2?.add(seconds, "seconds");

    if (years != 0) {
      return `${years}y ${months}m`;
    } else if (months >= 1) {
      return `${months}m ${weeks}w`;
    } else if (weeks >= 1) {
      return `${weeks}w ${days}d`;
    } else if (days >= 1) {
      return `${days}d ${hours}h`;
    } else if (hours >= 1) {
      if (hours) return `${this.addLeadingZero(hours)}h ${this.addLeadingZero(minutes)}m`;
    } else if (hours == 0 && minutes >= 1) {
      if (this.sec) {
        return `${this.addLeadingZero(minutes)}m ${this.addLeadingZero(seconds)}s`;
      } else {
        return `${this.addLeadingZero(minutes)}m`;
      }
    } else if (hours == 0 && minutes < 1 && seconds > 0) {
      if (this.flash) {
        return `00m ${this.addLeadingZero(seconds)}s`;
      } else {
        return `Now`;
      }
    } else {
      return this.expired;
    }
  }

  // Helper function to add leading zero if the number is a single digit
  addLeadingZero = (num: number): string => {
    return num.toString().length === 1 ? `0${num}` : num.toString();
  };
}
